import { CommonCarrierService } from '@savgroup-front-common/core/api';

import getCarrierLabelsInfosQuery from './getCarrierLabelsInfosQuery';
import getShippingLabelUrlQuery from './getShippingLabelUrlQuery';
import getVerifiedAddress from './getVerifiedAddress';

export const CarrierService = {
  getVerifiedAddress,
  getCarrierLabelsInfosQuery,
  getShippingLabelUrlQuery,
  getCarrierLabelUrlQuery: CommonCarrierService.getCarrierLabelUrlQuery,
  getCarrierLabelDocument: CommonCarrierService.getCarrierLabelDocument,
  getPickupPointByGeoCoordQuery:
    CommonCarrierService.getPickupPointByGeoCoordQuery,
};
